import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { useRecoilState } from "recoil";
import { activeAutom } from "../../../../recoil-store/recoil-state";
import AppCredential from "../AppCredential/AppCredential";

function ButtonItem({ action, variables, setOpenVariable, automId, showAlert, automVersionId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.WHATSAPP.LIST-ITEM.';
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);

    const [validation, setValidation] = useState([]);

    useEffect(() => {
        const inputsToValidate = [
            {
                type: "length",
                validation: {
                    operator: "lt",
                    value: 21
                }
            }
        ]
        setValidation(inputsToValidate);
    }, []);

    const updateLabel = (id, items) => {
        items.forEach(item => {
            if (item.id === id) {
                item.fields = action.fields;
            } else if (item.children) {
                updateLabel(id, item.children);
            }
        });
    };

    const handleBlur = () => {
        let fields = action.fields;
        let items = JSON.parse(JSON.stringify(automDetail.items));
        action.fields = JSON.parse(JSON.stringify(fields));
        updateLabel(action.id, items);
        setAutomDetail({ ...automDetail, items: JSON.parse(JSON.stringify(items)) });
    };

    return (
        <div>
            <AppCredential action={action} />
            <div className="form-element">
                {t(label + "LABEL")}
                <TextInput
                    action={action}
                    inputName="label"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    onBlur={handleBlur}
                    fieldType='string'
                    displayName={t(label + "LABEL")}
                />
            </div>
            <div className="form-element">
                {t(label + 'TITLE')}
                <TextInput action={action} inputName="title" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired={true} validation={validation} fieldType='string'
                    displayName={t(label + 'TITLE')} />
            </div>
            <div className="form-element">
                {t(label + 'RESPONSE')}
                <TextInput action={action} inputName="set" variables={variables} disabled={true}
                           setOpenVariable={setOpenVariable} rows={4} fieldType="string"  displayName= {t(label + 'RESPONSE')}/>
            </div>
        </div>
    );
}

export default ButtonItem;
